import { AppUsuario } from '../../../core/models/appUsuario.model';
import { AppUsuarioService } from '../../../core/services/appUsuarioService.service';
import { AppEmpresas } from './../../../core/models/appEmpresas.model';
import { AppEmpresasService } from './../../../core/services/appEmpresasService.service';
import { AppSeccion } from '../../../core/models/appSeccion.model';
import { AppSeccionesService } from '../../../core/services/appSeccionesService.service';
import { AppSendInviteService } from '../../../core/services/appSendInviteService.service';
import { AfterContentChecked, AfterContentInit, AfterViewInit, Component, EventEmitter, OnInit, Output, OnChanges, SimpleChanges, Inject, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { EditFormBase } from '../../../core/helper/EditFormBase';
import { SessionHelper } from '../../../core/helper/sessionHelper';
import { DOCUMENT, Location } from '@angular/common';
import { LicenseCheckerService } from '../../../core/helper/licenseChecker';
import { CalendarioComponent } from '../../calendario/calendario.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-empleados-detail',
  templateUrl: './empleados-detail.component.html',
  styleUrls: ['./empleados-detail.component.scss'],
  providers: [AppUsuarioService, AppEmpresasService, AppSeccionesService, AppSendInviteService,]
})
export class EmpleadosDetailComponent extends EditFormBase<AppUsuario, string> implements OnInit, OnChanges {

  // Propiedades del panel contenedor
  panelIcon = 'person'; // Material icon
  panelTitle = 'Empleado';
  panelDescription = 'Editar empleado';

  panelIconTwo = 'check'; // Material icon
  panelTitleTwo = 'Validaciones';
  panelDescriptionTwo = 'Validador del empleado';

  panelIconThree = 'description'; // Material icon
  panelTitleThree = 'Documentos';
  panelDescriptionThree = 'Documentos del empleado';


  userName: string;
  nif: string;
  name: string;
  surname: string;
  companyName: string;
  /*   role: string; */
  section: string;
  validatedBy: string;
  sectionName: string;
  /*  rolesSelected: string[]; */

  sectionModel: AppSeccion;
  value: any;
  enableSend: boolean = false;
  livesLicense: boolean;
  conectiaLicense: boolean;


  validUsername: boolean = false;
  validName: boolean = false;
  validSurname1: boolean = false;
  validSurname2: boolean = true; //como no es obligatorio por defecto está vacío y es válido
  validCompanyAppId: boolean = false;

  docsRead: {} = {};

  constructor(
    _route: ActivatedRoute,
    _modelService: AppUsuarioService,
    _messageDialog: MessageDialog,
    protected _sessionHelper: SessionHelper,
    _router: Router,
    _location: Location,

    private sectionsService: AppSeccionesService,
    private userService: AppUsuarioService,
    private sendInviteService: AppSendInviteService,
    private licenseCheckerService: LicenseCheckerService,

    protected _dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,

  ) {
    super(_modelService, _messageDialog, _route, _router, _location, AppUsuario);
    this.getModel();
    this.model = new AppUsuario();
    this.sectionModel = new AppSeccion();

    this.isNew = this.checkIsNew();
    /* this.rolesSelected = []; */

  }

  ngOnInit(): void {
    this.livesLicense = this.licenseCheckerService.checkLicense("livesHR");
    this.conectiaLicense = this.licenseCheckerService.checkLicense("conectia");

    if (!this.isNew) {
      var id = this.getUrlId();
      this._modelService.getModel(id).subscribe(user => {

        const userFound = user;
        if (userFound) {
          this.model.user1 = userFound.user1;
          this.model.mail = userFound.mail == null ? '---' : userFound.mail;
          this.model.nif = userFound.nif;
          this.model.name = userFound.name;
          this.model.surnames = userFound.surnames;
          this.model.company = userFound.company;
          this.model.section = userFound.section;
          this.model.enabled = userFound.enabled;
          this.model.address = userFound.address;

          this.validUsername = true
          this.validName = true
          this.validSurname1 = true
          this.validSurname1 = true
          this.validCompanyAppId = true
          /* this.model.roles = userFound.roles; */
          /*   this.model.rolesIds = []; */
          /*         userFound.roles.forEach((role) => {
                    if (role.role1 != '37244269-f567-4234-b012-a866d523c8e9') {
                      return this.model.rolesIds.push(role.role1);
                    }
                  }); */
        }

        this.sectionsService.getAllModelsByCompany(userFound.company.company1).subscribe(allModels => {
          const sectionFound = allModels.find(item => item.section1 == userFound.section.section1);
          this.sectionModel.name = sectionFound.name

          if (sectionFound.delegateResponsibleAllow) {

            this.sectionModel.delegateResponsibleName = sectionFound.delegateResponsibleName;

          }
          if (sectionFound.dualResponsibleAllow) {

            this.sectionModel.dualResponsibleName = sectionFound.dualResponsibleName;

          }

          if (sectionFound.validator) {
            this.sectionModel.validator = sectionFound.validatorName;

          } else {
            this.sectionModel.validator = '';
          }

        });

      });
    } else {
      this.model.company = { companyName: '', id: '', company1: '', identifierNumber: '', appId: '' };
    }

  }


  getUrlId(): string {
    var url = this._router.url.split('/');
    return url[url.length - 1]
  }

  onEditUser() {
    const data = {
      enabled: this.model.enabled
    }

    const dataOffline = {
      nif: this.model.nif,
      mail: this.model.mail,
      name: this.model.name,
      surname1: this.model.surname1,
      surname2: this.model.surname2,
      appId: this.model.company.appId,
      enabled: this.model.enabled,
    }

    this.userService.updateUserModel(this.model.user1, this.model.company.company1, this.conectiaLicense ? data : dataOffline).subscribe(
      (response) => {
        this._messageDialog.ShowMessage('Se han actualizado los datos del empleado', 'Datos actualizados',);
        if (!this.conectiaLicense) {
          this.model.company.companyName = response.company.companyName
        }

      },
      error => {
        // Hubo un error en la actualización de datos
        this._messageDialog.ShowAlert('Ha habido un error al actualizar los datos del empleado', 'Error al enviar');
        console.error(error)
      }
    )



  }

  onCreateUser() {
    const data = {
      nif: this.model.nif,
      mail: this.model.mail,
      name: this.model.name,
      surname1: this.model.surname1,
      surname2: this.model.surname2,
      appId: this.model.company.appId,
      enabled: this.model.enabled,
      sendInvitation: false
    }

    this.userService.createUserOffline(data).subscribe(
      (response) => {
        this._messageDialog.ShowContinueMessage('Se han creado el empleado correctamente. A continuación se redirigirá a la pantalla de edición donde podrá invitar al empleado.', 'Empleado creado',).then(() => {
          this._router.navigate(['/home', 'app', 'app-config', 'app-users', response.user1]);
        });

      },
      error => {
        // Hubo un error en la actualización de datos

        if (error?.errorCode && error?.errorCode === 'USER_ALREADY_EXISTS') {
          this._messageDialog.ShowAlert('Ha habido un error al crear el empleado, ya existe un empleado con ese NIF para esa empresa', 'Error al crear');

        } else {
          this._messageDialog.ShowAlert('Ha habido un error al crear el empleado', 'Error al crear');
        }
        console.error(error)
      }
    )

  }


  enabledSelectedChange(value: string) {
    if ((value === 'true') !== this.model.enabled) {
      this.model.enabled = (value === 'true');
    }
    if (!this.isNew && this.livesLicense) {
      this.enableSend = true
    } else {
      this.onEditableChange('Enabled');
    }
  }

  sendInvite() {
    // Verifica que el mail no sea vacío antes de proceder
    if (this.model.mail === '---') {
      this._messageDialog.ShowAlert(
        `El empleado no tiene acceso a la app`,
        'No se puede enviar la invitación'
      );
      return;
    }

    // Obtener el valor actualizado de "enabled" desde la base de datos
    this.userService.getModel(this.model.user1).subscribe(
      (user: AppUsuario) => {
        // Actualiza el valor de enabled desde la respuesta
        this.model.enabled = user.enabled;

        if (this.model.enabled) {
          const requestData = {
            user: this.model.user1,
            enabled: this.model.enabled,
            mail: this.model.mail,
            company: this.model.company.company1
          };

          // Enviar la invitación
          this.sendInviteService.sendInviteModel(requestData).subscribe(
            (response: any) => {
              this._messageDialog.ShowMessage(
                `Invitación enviada a ${this.model.mail}`,
                'Enviada'
              );
            },
            error => {
              this._messageDialog.ShowAlert(
                `El proceso de invitación falló`,
                'No se puede enviar la invitación'
              );
              console.error(error);
            }
          );
        } else {
          this._messageDialog.ShowAlert(
            `El empleado no está habilitado para acceder a la app`,
            'No se puede enviar la invitación'
          );
        }
      },
      error => {
        console.error('Error al obtener el usuario:', error);
        this._messageDialog.ShowAlert(
          `No se pudo obtener la información del empleado`,
          'Error al enviar'
        );
      }
    );
  }


  checkIsNew(): boolean {
    if (this._router.url.endsWith('new')) {
      return true
    } else {
      return false;
    }
  }

  onEditableChange(fieldChanged): void {

    switch (fieldChanged) {
      case 'UserName':
        if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.model.mail)) {
          this.validUsername = true
        } else {
          this.validUsername = false
        }
        break;

      case 'Name':
        if (/^[a-zA-ZÁÉÍÓÚáéíóúÑñ\s\-]+$/.test(this.model.name)) {
          this.validName = true;
        } else {
          this.validName = false;
        }
        break;

      case 'Surname1':
        if (/^[a-zA-ZÁÉÍÓÚáéíóúÑñ\s\-]+$/.test(this.model.surname1)) {
          this.validSurname1 = true;
        } else {
          this.validSurname1 = false;
        }
        break;

      case 'Surname2':
        if (/^[a-zA-ZÁÉÍÓÚáéíóúÑñ\s\-]+$/.test(this.model.surname2)) {
          this.validSurname2 = true;
        } else {
          this.validSurname2 = false;
        }
        break;

      default:
        break;
    }

    if (this.model.mail && this.model.name && this.model.surname1 && this.model.company.appId && this.model.nif && this.validUsername && this.validName && this.validSurname1 && this.validSurname2) {
      this.enableSend = true
    }
  }

  companySelectedChanged(companyData: number) {
    this.model.company.appId = companyData[0].appId;

    this.model.company.companyName = companyData[0].companyName;
    this.onEditableChange('company')
  }

  /*  roleSelectedChange(rolesSelected: string[]): void {
   
     rolesSelected.forEach((role) => {
       if (!this.rolesSelected.includes(role)) {
         this.rolesSelected.push(role);
       }
     });
   } */



  afterModelLoad(): void {
  }

  afterModelUpdated(): void {
  }

  getModelInstance(): AppUsuario {
    return new AppUsuario();
  }

  onOpenCalendar() {
    const dialogRef = this._dialog.open(CalendarioComponent, {
      width: '100%',
      data: { appointments: [], nullData: true, employee: this.model.user1, companyCode: this.model.company.companyCode, companyId: this.model.company.company1 }
    });

    const dialogContainer = this.document.querySelectorAll('.mat-dialog-container')[0];
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
      this.renderer.setStyle(dialogContainer, 'max-height', '90vh'); // Limita la altura del popup
      this.renderer.setStyle(dialogContainer, 'overflow-y', 'auto'); // Habilita scroll vertical
      this.renderer.addClass(dialogContainer, 'scrollable-section');
    }

    dialogRef.afterClosed().subscribe(result => {
      // this.getDataSource();
    });
  }

  
  afterModelCreated(success: boolean): void {
  }

}
